export default "__VITE_ASSET__CGNzOw$K__"